import { render, staticRenderFns } from "./NoteHeaderModal.vue?vue&type=template&id=763aed79&scoped=true&"
import script from "./NoteHeaderModal.vue?vue&type=script&lang=js&"
export * from "./NoteHeaderModal.vue?vue&type=script&lang=js&"
import style0 from "./NoteHeaderModal.vue?vue&type=style&index=0&id=763aed79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763aed79",
  null
  
)

export default component.exports